<template>
  <div>
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th></th>
          <th style="text-align:center" colspan="6">2019-2020</th>
          <th style="text-align:center" colspan="6">2020-2021</th>
        </tr>
        <tr>
          <th>{{name}}</th>
          <th>Statut</th>
          <th>CSC</th>
          <th>SSC</th>
          <th>Hôp.</th>
          <th>SLD</th>
          <th>SMD</th>
          <th>Statut</th>
          <th>CSC</th>
          <th>SSC</th>
          <th>Hôp.</th>
          <th>SLD</th>
          <th>SMD</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='value in hsps' :key='value.agency_id'>
          <td class="nom">
            <router-link :to="url(value.agency_id)" v-text="value.nom"></router-link>
          </td>
          <template v-if="value.pm1">
            <td v-text="value.pm1.statut"></td>
            <td class="x" :style="value.pm1.chc ? 'background-color: #f0f0ff;': ''">{{value.pm1   .chc ? "X" : ""}}</td>
            <td class="x" :style="value.pm1.css ? 'background-color: #f0f0ff;': ''">{{value.pm1.css ? "X" : ""}}</td>
            <td class="x" :style="value.pm1.hosp ? 'background-color: #f0f0ff;': ''">{{value.pm1.hosp ? "X" : ""}}</td>
            <td class="x" :style="value.pm1.ltc ? 'background-color: #f0f0ff;': ''">{{value.pm1.ltc ? "X" : ""}}</td>
            <td class="x" :style="value.pm1.mha ? 'background-color: #f0f0ff;': ''">{{value.pm1.mha ? "X" : ""}}</td>
          </template>
          <template v-else="">
            <td colspan="6"></td>
          </template>
          <template v-if="value.p0">
            <td v-text="value.p0.statut"></td>
            <td class="x" :style="value.p0.chc ? 'background-color: #f0f0ff;': ''">{{value.p0.chc ? "X" : ""}}</td>
            <td class="x" :style="value.p0.css ? 'background-color: #f0f0ff;': ''">{{value.p0.css ? "X" : ""}}</td>
            <td class="x" :style="value.p0.hosp ? 'background-color: #f0f0ff;': ''">{{value.p0.hosp ? "X" : ""}}</td>
            <td class="x" :style="value.p0.ltc ? 'background-color: #f0f0ff;': ''">{{value.p0.ltc ? "X" : ""}}</td>
            <td class="x" :style="value.p0.mha ? 'background-color: #f0f0ff;': ''">{{value.p0.mha ? "X" : ""}}</td>
          </template>
          <template v-else="">
            <td colspan="6"></td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
td.nom {
  max-width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
td.x {
  text-align: center;
}
</style>

<script>
export default {
  name: 'SSRSousRegion',
  props: {
    name: String,
    secteur: String,
    data: Object
  },
  computed: {
    hsps() {
      var hsps = Object.entries(this.data).map(a => a[1]);
      hsps.sort((a, b) => a.nom.localeCompare(b.nom));
      if(this.secteur!="") {
        hsps = hsps.filter(hsp => (hsp.pm1 && hsp.pm1[this.secteur]) ||
          (hsp.p0 && hsp.p0[this.secteur])
        )
      }
      return hsps;

    },
  },
  methods: {
    url(id) {
        return '/on/comparaison/'+id;
    }
  },
}
</script>
